var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shift-class',
  created () {
    this.search()
    this.getShop()
  },
  data () {
    return {
      searchCallbackFlag: false,
      hayaHoDefault: [],
      hayaHoDefaultEdit: null,
      hayaHoOptions: [],
      hayaHoOptionEditIndex: null,
      hayaKaDefault: [],
      hayaKaDefaultEdit: null,
      hayaKaOptions: [],
      hayaKaOptionEditIndex: null,
      nakaHoDefault: [],
      nakaHoDefaultEdit: null,
      nakaHoOptions: [],
      nakaHoOptionEditIndex: null,
      osoHoDefault: [],
      osoHoDefaultEdit: null,
      osoHoOptions: [],
      osoHoOptionEditIndex: null,
      osoKaDefault: [],
      osoKaDefaultEdit: null,
      osoKaOptions: [],
      osoKaOptionEditIndex: null,
      kyukaDefault: [],
      kyukaDefaultEdit: null,
      kyukaOptions: [],
      kyukaOptionEditIndex: null,
      sonotaDefault: [],
      sonotaDefaultEdit: null,
      sonotaOptions: [],
      sonotaOptionEditIndex: null,
      isEditing: false,
      searchShop: ''
    }
  },
  computed: {
    shiftClassHayaHoList () {
      return this.$store.getters.shiftClassHayaHoList
    },
    shiftClassHayaKaList () {
      return this.$store.getters.shiftClassHayaKaList
    },
    shiftClassNakaHoList () {
      return this.$store.getters.shiftClassNakaHoList
    },
    shiftClassOsoHoList () {
      return this.$store.getters.shiftClassOsoHoList
    },
    shiftClassOsoKaList () {
      return this.$store.getters.shiftClassOsoKaList
    },
    shiftClassKyukaList () {
      return this.$store.getters.shiftClassKyukaList
    },
    shiftClassSonotaList () {
      return this.$store.getters.shiftClassSonotaList
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    isSystemManagement () {
      return window.localStorage.getItem('user_authority') === '1'
    },
  },
  components: {
    AppHeader
  },
  methods: {
    search: function() {
      const shopId = this.searchShop || window.localStorage.getItem('shop_id')
      var data = {'shop_id': shopId}
      var self = this
      this.clearData()
      this.searchCallbackFlag = false
      var callback = function () {
        self.searchCallbackFlag = true
        // 早番・ホール
        for (var record of self.shiftClassHayaHoList) {
          if (record.attributes['is-default'] === 1) {
            self.hayaHoDefault.push(self.changeDataFormat(record))
          } else {
            self.hayaHoOptions.push(self.changeDataFormat(record))
          }
        }
        // 早番・カウンター
        for (var record of self.shiftClassHayaKaList) {
          if (record.attributes['is-default'] === 1) {
            self.hayaKaDefault.push(self.changeDataFormat(record))
          } else {
            self.hayaKaOptions.push(self.changeDataFormat(record))
          }
        }
        // 中番・ホール
        for (var record of self.shiftClassNakaHoList) {
          if (record.attributes['is-default'] === 1) {
            self.nakaHoDefault.push(self.changeDataFormat(record))
          } else {
            self.nakaHoOptions.push(self.changeDataFormat(record))
          }
        }
        // 遅番・ホール
        for (var record of self.shiftClassOsoHoList) {
          if (record.attributes['is-default'] === 1) {
            self.osoHoDefault.push(self.changeDataFormat(record))
          } else {
            self.osoHoOptions.push(self.changeDataFormat(record))
          }
        }
        // 遅番・カウンター
        for (var record of self.shiftClassOsoKaList) {
          if (record.attributes['is-default'] === 1) {
            self.osoKaDefault.push(self.changeDataFormat(record))
          } else {
            self.osoKaOptions.push(self.changeDataFormat(record))
          }
        }
        // 休暇
        for (var record of self.shiftClassKyukaList) {
          if (record.attributes['is-default'] === 1) {
            self.kyukaDefault.push(self.changeDataFormat(record))
          } else {
            self.kyukaOptions.push(self.changeDataFormat(record))
          }
        }
        // その他
        for (var record of self.shiftClassSonotaList) {
          if (record.attributes['is-default'] === 1) {
            self.sonotaDefault.push(self.changeDataFormat(record))
          } else {
            self.sonotaOptions.push(self.changeDataFormat(record))
          }
        }
      }
      this.$store.dispatch('SHIFT_CLASS_LIST', {data: data, callback: callback } )
    },
    getShop: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id === '800') {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    changeDataFormat: function(record) {
      var object = new Object
      object.id = (record)? record.id : null
      object.shop_id = this.searchShop || window.localStorage.getItem('shop_id')
      object.view_name = (record)? record.attributes['view-name'] : null
      object.select_name = (record)? record.attributes['select-name'] : null
      object.class_name = (record)? record.attributes['class-name'] : null
      object.time_from_hh = (record)? ('00' + record.attributes['time-from-hh']).slice(-2) : null
      object.time_from_mm = (record)? ('00' + record.attributes['time-from-mm']).slice(-2) : null
      object.time_to_hh = (record)? ('00' + record.attributes['time-to-hh']).slice(-2) : null
      object.time_to_mm = (record)? ('00' + record.attributes['time-to-mm']).slice(-2) : null
      object.break_time = (record)? record.attributes['break-time'] : null
      object.content = (record)? record.attributes['content'] : null
      object.is_default = (record)? record.attributes['is-default'] : 0
      return object
    },
    clearData: function() {
      this.hayaHoDefault = []
      this.hayaHoDefaultEdit = null
      this.hayaHoOptions = []
      this.hayaHoOptionEditIndex = null
      this.hayaKaDefault = []
      this.hayaKaDefaultEdit = null
      this.hayaKaOptions = []
      this.hayaKaOptionEditIndex = null
      this.nakaHoDefault = []
      this.nakaHoDefaultEdit = null
      this.nakaHoOptions = []
      this.nakaHoOptionEditIndex = null
      this.osoHoDefault = []
      this.osoHoDefaultEdit = null
      this.osoHoOptions = []
      this.osoHoOptionEditIndex = null
      this.osoKaDefault = []
      this.osoKaDefaultEdit = null
      this.osoKaOptions = []
      this.osoKaOptionEditIndex = null
      this.kyukaDefault = []
      this.kyukaDefaultEdit = null
      this.kyukaOptions = []
      this.kyukaOptionEditIndex = null
      this.sonotaDefault = []
      this.sonotaDefaultEdit = null
      this.sonotaOptions = []
      this.sonotaOptionEditIndex = null
    },
    onClickEnableDefaultEdit:function(indexName, index) {
      eval('this.'+indexName+'='+index)
      this.isEditing = true
    },
    onClickSaveDefault: function(recordName, index) {
      if (this.savingFlag) return false
      this.savingFlag = true
      var data = {}
      eval('data=this.'+recordName+'['+index+']')
      this.$store.dispatch('SHIFT_CLASS_UPDATE', { data: data, callback: this.onSaved, id: data.id, errorCallback: this.onSaved })
    },
    onClickCancel: function() {
      window.location.reload()
    },
    onClickAddOption: function(options, indexName) {
      var record = this.changeDataFormat()
      var index = 0
      eval('this.'+options+'.push(record)')
      eval('index = this.'+options+'.length - 1')
      eval('this.'+indexName+'='+index)
      if (options == 'kyukaOptions') {
        this.kyukaOptions[index].time_from_hh = 0
        this.kyukaOptions[index].time_from_mm = 0
        this.kyukaOptions[index].time_to_hh = 0
        this.kyukaOptions[index].time_to_mm = 0
        this.kyukaOptions[index].break_time = 0
      }
      this.isEditing = true
    },
    onClickEnableOptionEdit: function(indexName, index) {
      eval('this.'+indexName+'='+index)
      this.isEditing = true
    },
    onClickOptionDelete: function(shiftClassId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.savingFlag = true
        this.$store.dispatch('SHIFT_CLASS_DELETE', {id: shiftClassId, callback: this.onSaved})
      }
    },
    onClickSaveOption: function(className, index) {
      if (this.savingFlag) return false
      this.savingFlag = true
      var optionName = this.getOptionName(className)
      var data = null
      eval('data=this.'+optionName+'['+index+']')
      if (data) {
        if (data.id) {
          this.$store.dispatch('SHIFT_CLASS_UPDATE', { data: data, callback: this.onSaved, id: data.id, errorCallback: this.onSaved })
        } else {
          // 休暇及びその他以外
          if (className != 'f_kyuka' && className != 'g_sonota') {
            data.view_name = this.getViewName(className)
          }
          data.class_name = className
          this.$store.dispatch('SHIFT_CLASS_CREATE', {data: data, callback: this.onSaved})
        }
      }
    },
    onSaved: function() {
      this.isEditing = false
      this.savingFlag = false
      this.search()
    },
    getViewName: function(className) {
      if (className === 'a_haya_ho') {
        return '早番'
      } else if (className === 'b_haya_ka') {
        return '早番カ'
      } else if (className === 'c_naka_ho') {
        return '中番'
      } else if (className === 'd_oso_ho') {
        return '遅番'
      } else if (className === 'e_oso_ka') {
        return '遅番カ'
      } else if (className === 'f_kyuka') {
        return '休暇'
      } else if (className === 'g_sonota') {
        return 'その他'
      }
    },
    getOptionName: function(className) {
      if (className === 'a_haya_ho') {
        return 'hayaHoOptions'
      } else if (className === 'b_haya_ka') {
        return 'hayaKaOptions'
      } else if (className === 'c_naka_ho') {
        return 'nakaHoOptions'
      } else if (className === 'd_oso_ho') {
        return 'osoHoOptions'
      } else if (className === 'e_oso_ka') {
        return 'osoKaOptions'
      } else if (className === 'f_kyuka') {
        return 'kyukaOptions'
      } else if (className === 'g_sonota') {
        return 'sonotaOptions'
      }
    },
    existSameSelectName: function(object) {
      var value = object.select_name
      if (this.isBlank(value)) return false
      // 早番・ホール
      for (var record of this.hayaHoDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.hayaHoOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // 早番・カウンター
      for (var record of this.hayaKaDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.hayaKaOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // 中番・ホール
      for (var record of this.nakaHoDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.nakaHoOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // 遅番・ホール
      for (var record of this.osoHoDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.osoHoOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // 遅番・カウンター
      for (var record of this.osoKaDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.osoKaOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // 休暇
      for (var record of this.kyukaDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.kyukaOptions) {
        if (record !== object && record.select_name === value) return true
      }
      // その他
      for (var record of this.sonotaDefault) {
        if (record !== object && record.select_name === value) return true
      }
      for (var record of this.sonotaOptions) {
        if (record !== object && record.select_name === value) return true
      }
      return false
    },
    isNumerical: function(val) {
      if (!val) return true
      return utils.regex.numerical.test(val)
    },
    isBlank: function(val) {
      return utils.isBlank(val)
    },
    checkTimeFormat: function(object) {
      var time_from_hh = object.time_from_hh
      var time_from_mm = object.time_from_mm
      var time_to_hh = object.time_to_hh
      var time_to_mm = object.time_to_mm
      if (this.isBlank(time_from_hh) || this.isBlank(time_from_mm) || this.isBlank(time_to_hh) || this.isBlank(time_to_mm)) return 1
      if (!this.isNumerical(time_from_hh) || !this.isNumerical(time_from_mm) || !this.isNumerical(time_to_hh) || !this.isNumerical(time_to_mm)) return 2
      var time_from = ('00' + time_from_hh).slice(-2) + ('00' + time_from_mm).slice(-2)
      var time_to = ('00' + time_to_hh).slice(-2) + ('00' + time_to_mm).slice(-2)
      if (parseInt(time_from, 10) >= parseInt(time_to, 10)) return 3
      return 0
    },
    getTimeFormatError: function(object) {
      var errorcd = this.checkTimeFormat(object)
      if (errorcd === 1) return this.$t('validations.required')
      if (errorcd === 2) return this.$t('validations.invalid_number')
      if (errorcd === 3) return '時間帯の範囲を確認して下さい。'
      return ''
    },
    isInputErrorDefault: function(recordName, index) {
      var data = {}
      eval('data=this.'+recordName+'['+index+']')
      var ret = this.isBlank(data.select_name) ||
                !this.isNumerical(data.break_time) ||
                this.isBlank(data.break_time) ||
                this.checkTimeFormat(data) > 0
      return ret
    },
    isInputErrorOption: function(className, index) {
      var optionName = this.getOptionName(className)
      var data = null
      eval('data=this.'+optionName+'['+index+']')
      var ret = this.isBlank(data.select_name) ||
                this.existSameSelectName(data) ||
                !this.isNumerical(data.break_time) ||
                this.isBlank(data.break_time) ||
                this.checkTimeFormat(data) > 0
      if (className === 'f_kyuka' || className === 'g_sonota') {
        ret = ret || this.isBlank(data.view_name)
      }
      return ret
    },
    goBack: function() {
      this.$router.push({ path: '/shift_manage'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-class.js